<template>
    <div class="container">
        <div class="columns is-centered box has-background-dvolightgrey mt-4"> 
            <div class="column is-two-thirds">
                <h1 class="is-size-3 has-text-white has-text-centered">Match Parts to Products</h1>
                <b-field label="Enter part number">
                    <b-input v-model="partNumber" placeholder="Enter Part" id="snipe"></b-input>
                </b-field>
                <b-field label="Enter product code(s)">
                    <b-taginput
                        v-model="productIds"
                        :data="filteredProducts"
                        autocomplete
                        :allow-new="false"
                        :open-on-focus="true"
                        field="code"
                        icon="label"
                        @typing="getFilteredProducts">
                    </b-taginput>
                </b-field>
                <b-button class="is-dvogreen" @click="addParts()">Click Me</b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { API } from 'aws-amplify'
import { createProductPart } from '../graphql/mutations'
import { getProducts } from '../graphql/queries'

export default {
    data() {
            return {
                partNumber: null,
                products: [],
                filteredProducts: [],
                productIds: []
            }
        },
        methods: {
            async addParts() {
                for (let i = 0; i < this.productIds.length; i++) {
                    await API.graphql({
                        query: createProductPart,
                        variables: {
                            input: {
                                product_id: this.productIds[i].id,
                                part_number: this.partNumber
                            }
                        }
                    })
                }
            },
            async getProducts() {
                const Products = await API.graphql({
                    query: getProducts,
                    variables: {
                        input: {
                            request_type: 'read_all'
                        }
                    }
                });
                this.products = Products.data.getProducts;
            },
            getFilteredProducts(text) {
                this.filteredProducts= this.products.filter((option) => {
                    return option.code
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
            })
        },
    },
    mounted(){
        this.getProducts();
    }
}
</script>

<style lang="scss">
#snipe {
    background-color: #1a1a1a !important;
}
</style>